export default "__VITE_ASSET__7468c9a1__"